import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { LoginRoutingModule } from './login-routing.module';
import { FomanticUIModule } from 'ngx-fomantic-ui';

import { LoginComponent } from './components/login/login.component';
import { LoginContainerComponent } from './components/login-container/login-container.component';
import { RegistrationComponent } from './components/registration/registration.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { SocialLoginComponent } from './components/social-login/social-login.component';

const routes: Routes = [{ path: '', component: LoginContainerComponent }];

@NgModule({
  declarations: [
    LoginComponent,
    LoginContainerComponent,
    RegistrationComponent,
    ForgotPasswordComponent,
    SocialLoginComponent,
  ],
  imports: [
    CommonModule,
    FomanticUIModule,
    LoginRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule.forChild(routes),
  ],
})
export class LoginModule {}
